<template>
  <div id="page">
    <img src="./../../../images/hero-splash-2.jpeg" id="about" alt="About">
    <b-container>
      <section>
        <h1 class="text-center">Chi siamo</h1>
        <p>
          VadoBay è un sito di online travel booking che ti permette di acquistare servizi di viaggio con i crediti
          welfare messi a disposizione dalla tua azienda: niente voucher, niente coupon e niente carte di credito ma
          una prenotazione diretta e immediata usando il tuo credito welfare.
          <br><br>
          Tutto questo avviene con una tecnologia che sviluppiamo internamente e una <strong>collaborazione diretta con Expedia</strong>,
          uno tra i maggiori partner globali di servizi viaggi.
        </p>
      </section>
      <section>
        <h2>In più ti offriamo:</h2>
        <div class="checklist">
          <ul>
            <li class="checklist_item">
              <span class="checklist_icon"><SvgWhitelistSmall /></span>
              <span class="checklist_text">
                Un <strong>team di assistenza</strong> dedicato agli utenti welfare, senza bot o centralini dalle attese infinite.
                Puoi scriverci via email, chat, whatsapp; puoi chiamarci e parlare in italiano, inglese e spagnolo,
                e ci troverai pronti ad aiutarti.
              </span>
            </li>
            <li class="checklist_item">
              <span class="checklist_icon"><SvgDoubleCheckSmall /></span>
              <span class="checklist_text">
                Un servizio gratuito di <strong>Double Check</strong>: ebbene sì, ricontattiamo ogni struttura su cui è presente una
                prenotazione pochi giorni prima del check-in, per assicurarci che sia tutto pronto per il soggiorno degli ospiti.
                Spoiler: non lo fa nessun’altro.
              </span>
            </li>
            <li class="checklist_item">
              <span class="checklist_icon"><SvgSemplicitaSmall /></span>
              <span class="checklist_text">
                Una <strong>Whitelist</strong> che seleziona per te SOLO le strutture di qualità verificata e comprovata.
              </span>
            </li>
          </ul>
        </div>
        <p>Con Vadobay non hai brutte sorprese!</p>
      </section>
      <section>
        <h2>Come funziona</h2>
        <NumberedItems class="step" :items="numberedItems_comeFunziona" />
      </section>
      <section>
        <h2>Gli altri servizi Vadobay</h2>
        <b-row>
          <b-col md="6" lg="4">
            <b-card bg-variant="transparent" no-body class="border-0 align-items-center text-center">
              <b-card-img src="assets/brand-live-booking.svg" alt="Vadobay livebooking" />
              <b-card-body>
                <b-card-title class="h5">Vadobay livebooking</b-card-title>
                <b-card-text>per prenotare soggiorni presso oltre 600.000 hotel, appartamenti case e B&B.</b-card-text>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col md="6" lg="4">
            <b-card bg-variant="transparent" no-body class="border-0 align-items-center text-center">
              <b-card-img src="assets/brand-fly-by.svg" alt="Fly by Vadobay" />
              <b-card-body>
                <b-card-title class="h5"><a href="https://voli.vadobay.com/" target="_blank">Fly by Vadobay</a></b-card-title>
                <b-card-text>per prenotare voli di 700 compagnie sia di linea che low-cost tra cui Ryanair ed EasyJet.</b-card-text>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col md="6" lg="4">
            <b-card bg-variant="transparent" no-body class="border-0 align-items-center text-center">
              <b-card-img src="assets/brand-vacanze-by.svg" alt="Vacanze by Vadobay" />
              <b-card-body>
                <b-card-title class="h5"><a href="https://vacanze.vadobay.com/" target="_blank">Vacanze by Vadobay</a></b-card-title>
                <b-card-text>per prenotare un pacchetto del gruppo Alpitour.</b-card-text>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </section>
      <section>
        <p>
          VadoBay è un marchio <strong>Salabam Solutions</strong>. Se desideri conoscere l’intera gamma di servizi che possiamo offrire
          in ambito online travel booking, vieni a trovarci sul sito di <a href="https://www.salabamsolutions.com/">Salabam Solutions</a>!
        </p>
      </section>
      <div id="assistenza" class="mt-5 mb-5 d-flex justify-content-center">
        <router-link :to="{name: 'homepage'}">
          <BtnBack text="Torna alla Home" />
        </router-link>
      </div>
    </b-container>
  </div>
</template>

<script>
  import BtnBack from '../../atoms/btn-back'
  import NumberedItems from '../../blocks/common/numbered-items'
  import SvgSemplicitaSmall from '../../svg/semplicita-small'
  import SvgWhitelistSmall from '../../svg/whitelist-small'
  import SvgDoubleCheckSmall from '../../svg/double-check-small'

  export default {
    name: 'page',

    metaInfo: {
      title: 'informazioni',
    },

    components: {
      BtnBack,
      NumberedItems,
      SvgSemplicitaSmall,
      SvgWhitelistSmall,
      SvgDoubleCheckSmall,
    },

    data() {
      return {
        site: this.appConfig().site,
        numberedItems_comeFunziona : {
          0: {
            title: "Accedi al tuo portale welfare di riferimento",
          },
          1: {
            title: "Cerca uno dei portali " + this.appConfig().site.brand,
          },
          2: {
            title: "Prenota. Non riceverai voucher o coupon da spendere, solo una mail di conferma."
          },
          3: {
            title: "Buone vacanze!"
          }
        },
      }
    },

    mounted() {
    },

    methods:{
    }
  }
</script>

<style lang="scss">

  .checklist {

    &_item {
      display: flex;
      align-items: center;
      margin-bottom: 30px;
    }

    &_text {
      flex-basis: 90%;
    }

    &_icon {
      margin-right: 1rem;
      flex-basis: 10%;

      svg {
        min-width: 100%;
        height:auto;
      }
    }
  }

  .step {

    ul {
      display: block;
    }

    li {
      padding: 0 !important;
      margin-bottom: 0;
    }

    .heading {
      margin-bottom: 0;
    }

    .numbered {
      margin-bottom: 0;

      &_index {
        margin-right: 15px;
      }
    }
  }

  .card {
    a {
      color: #333;
      text-decoration: none;
    }

    img {
      width: 30%;
      height: 70px;
    }
  }

</style>